jQuery.keyboard.layouts["ms-Czech"] =
  name: "ms-Czech",
  lang: ["cs"],
  normal: [
    "; + ě š č ř ž ý á í é = ´ {bksp}",
    "{tab} q w e r t z u i o p ú ) {empty}",
    "a s d f g h j k l ů § {enter}",
    "{shift} \\ y x c v b n m , . / {shift}",
    "{accept} {alt} {space} {alt} {cancel}"
  ],
  shift: [
    "° 1 2 3 4 5 6 7 8 9 0 % ˇ {bksp}",
    "{tab} Q W E R T Z U I O P / ( '",
    'A S D F G H J K L " ! {enter}',
    "{shift} | Y X C V B N M ? : / {shift}",
    "{accept} {alt} {space} {alt} {cancel}"
  ],
  alt: [
    "{empty} ~ ˇ ^ ˘ ° ˛ ` ˙ ´ ˝ ¨ ¸ {bksp}",
    "{tab} \\ | € {empty} {empty} {empty} {empty} {empty} {empty} {empty} ÷ × ¤",
    "{empty} đ Đ [ ] {empty} {empty} ł Ł $ ß {enter}",
    "{shift} {empty} {empty} # & @ { } {empty} < > {empty} {shift}",
    "{accept} {alt} {space} {alt} {cancel}"
  ]

jQuery.keyboard.layouts["ms-Czech-less-actions"] =
  name: "ms-Czech",
  lang: ["cs"],
  normal: [
    "; + ě š č ř ž ý á í é = ´ {bksp}",
    "{sp:0.8} q w e r t z u i o p ú )",
    "{sp:1.3} a s d f g h j k l ů § {empty}",
    "{sp:0.3} {shift} y x c v b n m , . / {shift}",
    "{accept} {alt} {space} {alt} {clear}"
  ],
  shift: [
    "° 1 2 3 4 5 6 7 8 9 0 % ˇ {bksp}",
    "{sp:0.8} Q W E R T Z U I O P / (",
    "{sp:1.3} A S D F G H J K L \" ! '",
    "{sp:0.3} {shift} Y X C V B N M ? : / {shift}",
    "{accept} {alt} {space} {alt} {clear}"
  ],
  alt: [
    "{empty} ~ ˇ ^ ˘ ° ˛ ` ˙ ´ ˝ ¨ ¸ {bksp}",
    "{sp:0.8} \\ | € {empty} {empty} {empty} {empty} {empty} {empty} {empty} ÷ ×",
    "{sp:1.3} {empty} đ Đ [ ] {empty} {empty} ł Ł $ ß ¤",
    "{sp:0.3} {shift} {empty} # & @ { } {empty} < > {empty} {shift}",
    "{accept} {alt} {space} {alt} {clear}"
  ]

jQuery.keyboard.layouts["ms-Czech (QWERTY)"] =
  name: "ms-Czech (QWERTY)",
  lang: ["cs"],
  normal: [
    "; + ě š č ř ž ý á í é = ´ {bksp}",
    "{tab} q w e r t y u i o p ú ) {empty}",
    "a s d f g h j k l ů § {enter}",
    "{shift} \\ z x c v b n m , . / {shift}",
    "{accept} {alt} {space} {alt} {cancel}"
  ],
  shift: [
    "° 1 2 3 4 5 6 7 8 9 0 % ˇ {bksp}",
    "{tab} Q W E R T Y U I O P / ( '",
    'A S D F G H J K L " ! {enter}',
    "{shift} | Z X C V B N M ? : / {shift}",
    "{accept} {alt} {space} {alt} {cancel}"
  ],
  alt: [
    "` ! @ # $ % ^ & * ( ) - = {bksp}",
    "{tab} {empty} {empty} € {empty} {empty} {empty} {empty} {empty} {empty} {empty} [ ] \\",
    "{empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} ; ¤ {enter}",
    "{shift} ß {empty} {empty} {empty} {empty} {empty} {empty} {empty} < > {empty} {shift}",
    "{accept} {alt} {space} {alt} {cancel}"
  ],
  "alt-shift": [
    "~ {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} _ + {bksp}",
    "{tab} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} { } |",
    "{empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} : ^ {enter}",
    "{shift} ˝ {empty} {empty} {empty} {empty} {empty} {empty} {empty} × ÷ {empty} {shift}",
    "{accept} {alt} {space} {alt} {cancel}"
  ]

jQuery.keyboard.layouts["ms-Czech Programmers"] =
  name: "ms-Czech Programmers",
  lang: ["cs"],
  normal: [
    "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
    "{tab} q w e r t y u i o p [ ] \\",
    "a s d f g h j k l ; ' {enter}",
    "{shift} \\ z x c v b n m , . / {shift}",
    "{accept} {alt} {space} {alt} {cancel}"
  ],
  shift: [
    "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
    "{tab} Q W E R T Y U I O P { } |",
    'A S D F G H J K L : " {enter}',
    "{shift} | Z X C V B N M < > / {shift}",
    "{accept} {alt} {space} {alt} {cancel}"
  ],
  alt: [
    "; + ě š č ř ž ý á í é = ´ {bksp}",
    "{tab} {empty} {empty} € {empty} {empty} {empty} {empty} {empty} {empty} {empty} ú ) {empty}",
    "{empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} ů § {enter}",
    "{shift} ß {empty} {empty} {empty} {empty} {empty} {empty} {empty} ? : {empty} {shift}",
    "{accept} {alt} {space} {alt} {cancel}"
  ],
  "alt-shift": [
    "° {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} % ˇ {bksp}",
    "{tab} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} / ( {empty}",
    '{empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} {empty} " ! {enter}',
    "{shift} ˝ {empty} {empty} {empty} {empty} {empty} {empty} {empty} × ÷ {empty} {shift}",
    "{accept} {alt} {space} {alt} {cancel}"
  ]
